<template>
    <header>
        <div class="logo">
             <router-link class="menu-link light" to="/">
                <img src="./../../assets/logo.png" alt="logo synthes3d" />
            </router-link>
        </div>
        <nav class="menu-desk">   
            <ul >
                <li>
                    <router-link class="menu-link light" to="/" exact>Accueil</router-link>
                </li>
                <div class="menu-sep "></div>
                <li>
                    <router-link class="menu-link light" to="/solutions">Solutions</router-link>
                </li>
                 <div class="menu-sep "></div>
                <li class="menu-services">
                    <router-link class="menu-link  light" to="/services">Services</router-link>
                    <div class="sub-menu">
                        <ul>
                            <li>
                                <router-link class="menu-link light" to="/services#inbound">Inbound marketing</router-link>
                            </li>
                            <li>
                                <router-link class="menu-link light" to="/services#abonnement">Nos abonnements</router-link>
                            </li>
                            <li>
                                <router-link class="menu-link light" to="/services#comparatif">Comparatif</router-link>
                            </li>
                        </ul>
                    </div>
                </li>
                <div class="menu-sep"></div>
                <li>
                    <router-link class="menu-link light" to="/portfolio">Portfolio</router-link>
                </li>
                <div class="menu-sep"></div>
                <li>
                    <router-link class="menu-link light" to="/contact">Contact</router-link>
                </li>
            </ul>
        </nav>
        <div class="menu-mobile">
             <Slide class="s3d-menu" right width="250">
                <ul >
                    <li>
                        <router-link class="menu-link light" to="/home">Accueil</router-link>
                    </li>
                    <div class="menu-sep "></div>
                    <li>
                        <router-link class="menu-link light" to="/solutions">Solutions</router-link>
                    </li>
                    <div class="menu-sep "></div>
                    <li>
                        <router-link class="menu-link light" to="/services">Services</router-link>
                    </li>
                    <div class="menu-sep"></div>
                    <li>
                        <router-link class="menu-link light" to="/portfolio">Portfolio</router-link>
                    </li>
                    <div class="menu-sep"></div>
                    <li>
                        <router-link class="menu-link light" to="/contact">Contact</router-link>
                    </li>
                </ul>
            </Slide>
        </div>
        <div class="header-tel thin">
            <span>+33 (0)9</span> 70 66 97 04
        </div>
    </header>
</template>


<script>
import { Slide } from 'vue-burger-menu' 

export default {
    name: 'the-header',   
    components : {
        Slide
    }
}
</script>

<style scoped>


header {
    background: rgba(26 , 26 ,35 , 0.8);
    height:100px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding:0 80px;
    position:absolute;
    top:0;
    left:0;
    right:0;    
    z-index:9999;
}

.logo {
    width:25%;
}

.menu-desk {
    width:60%;
    height:100%;
    align-items: center;
    display: flex;
    justify-content: center;
}

.menu-mobile {
    display: none;
}

.menu-desk  ul {
    list-style: none;
    padding:0;
    margin: 0;
    display: flex;
    flex-direction: row;
    height:100%;
    align-items:center;
}

.menu-desk  ul li, .menu-desk  ul li a {
    height:100%;
    align-items:center;
}

.menu-desk  ul li a {
    display: flex;
}

.menu-link {
    text-decoration: none;
    position:relative;
    font-size:15px;    
    color:#ffffff;
    padding:0 20px;
    letter-spacing: 3px;
}

.menu-link:hover, .router-link-active {
    color:#fbab37;
}

.menu-sep {   
    margin-top: 5px;
    background: #fbab37;
    width:6px;
    height:6px;
    border-radius:50%;
}

.header-tel {
    font-size:20px;
    color:#ffffff;
    width:15%;
    text-align: right;
}

.header-tel span {
    color:#fbab37;
}

.phone {
    display: none;
}

.sub-menu {
    display:none;
}

.menu-services:hover .sub-menu{
    display: flex;    
    position:absolute;
    background:rgba(26 , 26 ,35 , 0.9);
    padding:10px 20px;
    top:100px;  
    width:200px;  
}

.sub-menu ul {
    display: flex;
    flex-direction: column;
}

.sub-menu li {
    padding: 15px 0;
    justify-content: flex-start;
    width: 100%;
}

.sub-menu a {
    padding:0;
    justify-content: flex-start;
}

.menu-services {
    position: relative;
}

@media screen and (max-width: 1300px) {
    .menu-desk {
        display:none;
    }

    .menu-mobile {
        display: block;
    }

    .logo {
        width: 75%;
    }

    .logo  a {
        padding:0;
        max-width: 100%;
        
    }

    .logo img {
        max-width: 80%;
        margin-left:10px;
    }

    header {
        position: relative;
        height:50px;
        padding:20px !important;
    }

    .header-tel {
        display: none;
    }

    .menu-sep {
        display:none;
    }

    .menu-mobile ul {
         list-style: none;
        padding:0;
        margin: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .menu-mobile ul li {
        margin:10px 0;
    }


}

@media screen and (max-width: 1650px) {
    header {
        padding:0 10px;
    }

    .menu-link  {
        padding: 0 20px;
    }
}


</style>